export type InvestmentClient = {
  clientId: number
  statusId: number
  isTutorialCompleted: boolean
  Client?: {
    legalName: string
    Accounts: [
      {
        number: string
      }
    ]
  }
}

export enum InvestmentOrderType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  RESCUE = 'RESCUE'
}

export interface InvestmentHours {
  subscription: string[]
  rescue: string[]
}

export interface InvestmentOrder {
  lastExternalStatus?: string
  externalId?: string
  id: number
  type: InvestmentOrderType
  amount: number
  operatedAmount?: number
  createdAt: Date
  updatedAt?: Date
  investmentClientId?: number
  movementId?: number | null
  statusId: number
  InvestmentClient?: InvestmentClient
}

export interface InvestmentHolidays {
  day: string
  reason: string
}

export interface Fund {
  minimumAmount: number
  goalSummary: string
  tradingCurrency: string
  fundInvestorProfile: string
  fundSubscriptionOpenHour: string
  fundSubscriptionCloseHour: string
  fundRescueOpenHour: string
  fundRescueCloseHour: string
}

export interface InvestmentOrderWithActivityData extends InvestmentOrder {
  activityData: {
    type: InvestmentOrderType
    status: number
  }
  account?: string
}
export interface InvestmentsState {
  tutorialCompleted: boolean | null
  isLoading: boolean
  isError: boolean
  isBalanceHoldingError: boolean
  investedBalance: string | number
  performance: any
  investmentClient?: InvestmentClient
  investmentClientLoading: boolean
  balanceHoldingAccount: string
  loadingHoldingAccount: boolean
  lastPerformance: number
  authorization: boolean | null
  orders: InvestmentOrder[]
  investmentHours: InvestmentHours
  fund?: Fund
  investmentHolidays: InvestmentHolidays[]
  selected?: InvestmentOrderWithActivityData
  isParamsLoading: boolean,
  isTutorialLoading: boolean
}

export enum InvestmentType {
  SUBSCRIPTION = 'buy',
  RESCUE = 'sell'
}

export interface HoldingAccount {
  holding_id: string
  price: number
  name: string
  asset_type: number
  group: string
  current_position_value: string
  trading_currency: string
  fund_id: string
  fund_minimum_amount: number
  available_quantity: number
  frozen_quantity: number
  quantity: number
  available: string
}

export interface LastPerformance {
  percentual_diff: number
  absolute_diff: number
}
export interface Authorization {
  data: boolean
}

export interface InvestmentParams {
  authorized: boolean
  holidays: InvestmentHolidays[]
  investmentHours: InvestmentHours
}

export enum InvestmentsActionTypes {
  LOGOUT = '@INVESTMENTS:LOGOUT',
  SET_LOADING = '@INVESTMENTS:SET_LOADING',
  DISMISS_LOADING = '@INVESTMENTS:DISMISS_LOADING',
  CREATE_ACCOUNT = '@INVESTMENTS:CREATE_ACCOUNT',
  GET_OPERATIONS = '@INVESTMENTS:GET_OPERATIONS',
  SET_INVESTMENT_BALANCE = '@INVESTMENTS:SET_INVESTMENT_BALANCE',
  SET_PERFORMANCE = '@INVESTMENTS:SET_PERFORMANCE',
  GET_TUTORIAL_COMPLETION_PENDING = '@INVESTMENTS:GET_TUTORIAL_COMPLETION_PENDING',
  GET_TUTORIAL_COMPLETION_REJECTED = '@INVESTMENTS:GET_TUTORIAL_COMPLETION_REJECTED',
  GET_TUTORIAL_COMPLETION_FULFILLED = '@INVESTMENTS:GET_TUTORIAL_COMPLETION_FULFILLED',
  GET_IS_TUTORIAL_COMPLETED_PENDING = '@INVESTMENTS:GET_IS_TUTORIAL_COMPLETED_PENDING',
  GET_IS_TUTORIAL_COMPLETED_REJECTED = '@INVESTMENTS:GET_IS_TUTORIAL_COMPLETED_REJECTED',
  GET_IS_TUTORIAL_COMPLETED_FULFILLED = '@INVESTMENTS:GET_IS_TUTORIAL_COMPLETED_FULFILLED',
  GET_INVESTMENT_CLIENT_PENDING = '@INVESTMENTS:GET_INVESTMENT_CLIENT_PENDING',
  GET_INVESTMENT_CLIENT_REJECTED = '@INVESTMENTS:GET_INVESTMENT_CLIENT_REJECTED',
  GET_INVESTMENT_CLIENT_FULFILLED = '@INVESTMENTS:GET_INVESTMENT_CLIENT_FULFILLED',
  SET_SUBSCRIPTION_PENDING = '@INVESTMENTS:SET_SUBSCRIPTION_PENDING',
  SET_SUBSCRIPTION_REJECTED = '@INVESTMENTS:SET_SUBSCRIPTION_REJECTED',
  SET_SUBSCRIPTION_FULFILLED = '@INVESTMENTS:SET_SUBSCRIPTION_FULFILLED',
  SET_RESCUE_PENDING = '@INVESTMENTS:SET_RESCUE_PENDING',
  SET_RESCUE_REJECTED = '@INVESTMENTS:SET_RESCUE_REJECTED',
  SET_RESCUE_FULFILLED = '@INVESTMENTS:SET_RESCUE_FULFILLED',
  GET_HOLDING_ACCOUNT_PENDING = '@INVESTMENTS:GET_HOLDING_ACCOUNT_PENDING',
  GET_HOLDING_ACCOUNT_FULFILLED = '@INVESTMENTS:GET_HOLDING_ACCOUNT_FULFILLED',
  GET_HOLDING_ACCOUNT_REJECTED = '@INVESTMENTS:GET_HOLDING_ACCOUNT_REJECTED',
  GET_LAST_PERFORMANCE_PENDING = '@INVESTMENTS:GET_LAST_PERFORMANCE_PENDING',
  GET_LAST_PERFORMANCE_FULFILLED = '@INVESTMENTS:GET_LAST_PERFORMANCE_FULFILLED',
  GET_LAST_PERFORMANCE_REJECTED = '@INVESTMENTS:GET_LAST_PERFORMANCE_REJECTED',
  GET_ORDERS_PENDING = '@INVESTMENTS:GET_ORDERS_PENDING',
  GET_ORDERS_FULFILLED = '@INVESTMENTS:GET_ORDERS_FULFILLED',
  GET_ORDERS_REJECTED = '@INVESTMENTS:GET_ORDERS_REJECTED',
  GET_FUND_PENDING = '@INVESTMENTS:GET_FUND_PENDING',
  GET_FUND_FULFILLED = '@INVESTMENTS:GET_FUND_FULFILLED',
  GET_FUND_REJECTED = '@INVESTMENTS:GET_FUND_REJECTED',
  GET_INVESTMENT_PARAMS_PENDING = '@INVESTMENTS:GET_INVESTMENT_PARAMS_PENDING',
  GET_INVESTMENT_PARAMS_FULFILLED = '@INVESTMENTS:GET_INVESTMENT_PARAMS_FULFILLED',
  GET_INVESTMENT_PARAMS_REJECTED = '@INVESTMENTS:GET_INVESTMENT_PARAMS_REJECTED',
  SET_CANCEL_INVESTMENT_ORDER_PENDING = '@INVESTMENTS:SET_CANCEL_INVESTMENT_ORDER_PENDING',
  SET_CANCEL_INVESTMENT_ORDER_FULFILLED = '@INVESTMENTS:SET_CANCEL_INVESTMENT_ORDER_FULFILLED',
  SET_CANCEL_INVESTMENT_ORDER_REJECTED = '@INVESTMENTS:SET_CANCEL_INVESTMENT_ORDER_REJECTED',
  SET_SELECT_INVESTMENT_ORDER = '@INVESTMENTS:SET_SELECT_INVESTMENT_ORDER'
}

export enum InvestmentStatus {
  'Executed' = 1,
  'Pending' = 2,
  'Rejected' = 3,
  'ManualAction' = 4,
  'NotSendedInvera' = 5,
  'Canceled' = 6
}

export interface InvestmentOrderDetail {
  id?: number | null
  date: Date | string
  amount: string
  account: string
  type: InvestmentOrderType
  statusId: number
}
